module.exports = __webpack_public_path__ + "img/sweden-respiratory-diseases-female.5faf4806.png";